import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {change, Field} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';

/**
 * A SelectInput component with Product choices populated from Product Type and Category.
 *
 */
class ProductByTypeCategoryDependentSelectInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            catParam: null,
            typeParam: null,
            selectChoices: [],
            selectedId: null
        };

        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentDidMount() {
        if (
            !this.props.dependsOn ||
            (this.props.dependsOn && this.props.dependsOnValue)
        ) {
            this.fetchData(this.props);
        }
        if (this.props.forceReset) {
            this.props.dispatch(change(this.props.formReference, this.props.sourceName, ''));
        }
    }

    componentWillReceiveProps(nextProps) {
        // If typeName changes value, update the value
        const thisDepends = this.props.dependsOnValue;
        if (nextProps.dependsOnValue.type !== thisDepends.type || nextProps.dependsOnValue.category_id !== thisDepends.category_id) {
            this.setState({
                typeParam: nextProps.dependsOnValue.type,
                catParam: nextProps.dependsOnValue.category_id,
                selectedId: null,
            });
            this.props.dispatch(change(this.props.formReference, this.props.sourceName, ''));
        }
    }

    componentDidUpdate(prevProps) {
        // If type or category value changes, retrieve data
        const thisDepends = this.props.dependsOnValue;

        if (prevProps.dependsOnValue.type !== thisDepends.type || prevProps.dependsOnValue.category_id !== thisDepends.category_id) {
            this.fetchData(this.props);
        }
    }

    fetchData(props) {
        const thisDepends = props.dependsOnValue;
        // Assemble the URI
        const params = {
            filter: {
                type: encodeURIComponent(thisDepends.type),
                category_id: encodeURIComponent(thisDepends.category_id)
            },
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"}
        };
        const resource = productResources.Products.GET_LIST(params);

        // Retrieve the data and assign results to the Select choices
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        let choices = this.assembleChoiceNames(result.data.payload);
                        this.setState({
                            selectChoices: choices
                        });
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    assembleChoiceNames(choices) {
        for (let choice of choices) {
            const id = choice.id;
            const name = (choice.name) ? ' - ' + choice.name : '';
            choice.name = id + name;
        }
        return choices;
    }

    handleSelectChange(event, index) {
        const selectedId = index;
        // Retrieve the Product from the choices list based on the selected ID
        if (selectedId) {
            const product = this.state.selectChoices.find(p => p.id === selectedId);
            if (product) {
                this.setState({
                    selectedId: selectedId
                });
                this.props.dispatch(change(this.props.formReference, this.props.sourceName, product.id));
            }
        } else {
            this.setState({
                selectedId: ''
            });
            this.props.dispatch(change(this.props.formReference, this.props.sourceName, ''));
        }
    }

    render() {
        return (
            <span>
               <Field name={this.props.sourceName}
                      component={VirtualizedSelectInput}
                      choices={this.state.selectChoices}
                      label={this.props.label}
                      optionText="name"
                      onChange={this.handleSelectChange}
                      allowEmpty
                      options={{
                          className: this.props.className,
                          clearable: false,
                          placeholder: this.props.label,
                      }}
               />
            </span>
        );
    }
}

function mapStateToProps(state, props) {
    let filterValue = null;
    if (props.dependsOn && props.formReference) {
        let formState = state.form[props.formReference];
        filterValue = formState.values[props.dependsOn];
        return {
            dependsOnValue: filterValue
        }
    }

    return {
        isLoading: false
    };
}

ProductByTypeCategoryDependentSelectInput.propTypes = {
    addField: PropTypes.bool.isRequired,
    className: PropTypes.string,
    formReference: PropTypes.string,
    dependentFilterValue: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number,
        PropTypes.string,
    ]),
    forceReset: PropTypes.bool,
    resource: PropTypes.string,
    selectedId: PropTypes.string,
    sourceName: PropTypes.string
};

ProductByTypeCategoryDependentSelectInput.defaultProps = {
    addField: true,
    className: '',
    dependentFilterValue: null,
    forceReset: false,
    formReference: null,
    resource: "Products",
    selectedId: null,
    sourceName: 'product_id'
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(ProductByTypeCategoryDependentSelectInput);



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductByTypeCategoryDependentSelectInput.js